import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import InsightsSection from '../Components/analyst/InsightsSection'
import FeaturedViews from '../Components/analyst/FeaturedViews'
import { Helmet } from "react-helmet-async";

function Analyst() {
  return (
    <div>
      <Helmet>
    <title>
        Analyst Insights | Industry Analysis & Technology Insights | Mobikode
    </title>

    <meta
        name="description"
        content="Explore Mobikode's analyst insights, industry perspectives, technology analysis, expert views, and the latest developments shaping Enterprise AI & ServiceNow Consulting and business innovation."
    />

    <meta
        name="keywords"
        content="Mobikode Analyst Insights, Analyst Insights, Technology Analyst Insights, Industry Analysis, Technology Analysis, Enterprise AI & ServiceNow Consulting Insights, IT Industry Insights, Business Insights, Technology Trends, Expert Views, Industry Perspectives, Mobikode Insights"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/analyst-insights"
    />

    <meta
        property="og:title"
        content="Analyst Insights | Industry Analysis & Technology Insights | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's analyst insights and perspectives on technology, Enterprise AI & ServiceNow Consulting, industry trends, innovation, and business growth."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/analyst-insights"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/analyst/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Analyst Insights | Industry Analysis & Technology Insights | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Stay informed with Mobikode's latest analyst insights, technology analysis, industry perspectives, expert views, and Enterprise AI & ServiceNow Consulting trends."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/analyst/bg1.png"
    />
</Helmet>
      <WhoHero
        title="Analyst Insights"
        text="Find our latest work and collaborations"
        imgData="/assets/analyst/bg1.png"
      />
      <InsightsSection />
      <FeaturedViews />
    </div>
  )
}

export default Analyst
